export enum EAdminUrl {
  ADMIN = 'admin/api/v2',
}
